import { render, staticRenderFns } from "./campusDetailBanner.vue?vue&type=template&id=7c3588d8&scoped=true"
import script from "./campusDetailBanner.vue?vue&type=script&lang=js"
export * from "./campusDetailBanner.vue?vue&type=script&lang=js"
import style1 from "./campusDetailBanner.vue?vue&type=style&index=1&id=7c3588d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3588d8",
  null
  
)

export default component.exports